// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"88":"login-page","316":"register-page","811":"training-page","913":"library-page"}[chunkId] || chunkId) + "." + {"88":"967137c6","134":"7022533b","316":"dd0b9277","415":"c1eedaa4","811":"4051d3ef","913":"41367bf4","954":"1c293562"}[chunkId] + ".chunk.js";
};